import { createI18n } from 'vue-i18n'

// Define RTL languages
const rtlLangs = ['ar'];

// Function to set the document's writing direction
export function setDocumentDirection(locale) {
  if (rtlLangs.includes(locale)) {
    document.documentElement.dir = 'rtl';
  } else {
    document.documentElement.dir = 'ltr';
  }
  
  // Set the lang attribute for font selection
  document.documentElement.lang = locale;
}

// Function to load locale messages from JSON files
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const initialLocale = localStorage.getItem('user-locale') || process.env.VUE_APP_I18N_LOCALE || 'en';

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  globalInjection: true,
})

// Set the initial direction
setDocumentDirection(initialLocale);

export default i18n 